import {useCallback} from "react";
import {call} from "redux-saga/effects";
import {useSagaCallback} from "../store/sagas";
import {apiPost} from "./client";

export const useHardRemove = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (content_id, content_type) {
        yield call(apiPost, `/api/v2/admin/hard_remove.json`, {
            id: content_id,
            type: content_type,
        });
    }, []));
};

export const useSetCommunityCreation = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (author) {
        yield call(apiPost, `/api/v2/admin/set_create_community.json`, {
            username: author
        });
    }, []));
};
